Vendd.Scripts.load(function () {

    var $wrapper = $('.x-product-details'),
        wrapper;
    var model = null, firstLoad = true, lazyLoadSender = false,
        wishlistModel, compareModel;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    //example: bundleItems: [{bundleProductId:'testValue', parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
    var bundleItems = [];

    var $bundleItems = $('.js-bundle-item-list .js-bundle-item', $wrapper);
    $.each($bundleItems, function (i, control) {
        var $control = $(control);
        var isDynamic = $control.data('is-dynamic').toLowerCase() === 'true';
        var bundleProductId = parseInt($control.data('bundle-id'));
        var parentProductId = $control.data('parent-id');
        var productId = $control.data('selected-id');

        var $qty = $('.js-quantity', $control);

        if (isDynamic) {
            bundleItems.push({
                bundleProductId: bundleProductId,
                parentProductId: parentProductId,
                productId: productId,
                quantity: parseInt($qty.val())
            });
        }
    });

    var recipeItems = [];
    var comboItems = [];
    var minQuantity = ($wrapper.data('min-quantity') ? stringToNumber($wrapper.data('min-quantity')) : null) || 0;
    var maxQuantity = ($wrapper.data('max-quantity') ? stringToNumber($wrapper.data('max-quantity')) : null) || 0;
    var quanta = ($wrapper.data('quanta') ? stringToNumber($wrapper.data('quanta')) : null) || 0;
    var qty;
    if (quanta) {
        qty = Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(quanta) > parseInt(minQuantity) ? parseInt(quanta) : parseInt(minQuantity) : parseFloat(quanta) > parseFloat(minQuantity) ? parseFloat(quanta) : parseFloat(minQuantity);
    } else {
        qty = 1;
    }

    Vendd.Product.Controller.initState({
        serviceConfiguration: $('.service-configuration', $wrapper).text(),
        parentId: $wrapper.data('parent-id'),
        selectedId: $wrapper.data('selected-id'),
        selectedColorId: $wrapper.data('selected-color-id'),
        path: $wrapper.data('path'),
        languageId: $wrapper.data('language-id'),
        qty: qty > 0 ? qty : 1,
        minQuantity: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(minQuantity) : parseFloat(minQuantity),
        maxQuantity: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(maxQuantity) : parseFloat(maxQuantity),
        quanta: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(quanta) : parseFloat(quanta),
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems
    });

    $('.service-configuration', $wrapper).remove();

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    var merchantPopUp = function (model) {

        var html = Vendd.Handlebars.parse("merchantBox_B", model);

        $.fancybox.open(html, {
            type: 'iframe',
            maxWidth: 1040,
            fitToView: false,
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            padding: 0
        });

    };

    wrapper.bind = function () {
        
      
        if ($wrapper.hasClass('x-product-details-popup') || LhApp.Context.MultipleWishlistsEnabled) {
            Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($('.x-product-details-ajax-buttons', $wrapper)));
        } else {
            Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($('.x-product-list', $wrapper)));
        }

        var scrollOffset;
        if ($('.js-go-to-size-guide').length > 0 && !$wrapper.hasClass('x-product-details-popup')) {
            $('.js-go-to-size-guide', $wrapper).click(function () {
                scrollOffset = $(window).outerWidth() > 960 ? 100 : 50;
                $('.product-details-region .x-pd-tab-panel .tab-title.size-guide').trigger('click');
                $('html, body').animate({ scrollTop: $('.product-details-region .x-pd-tab-panel .tab-content.size-guide').offset().top - scrollOffset }, 1);
            }); 
        }

        InitStickyBar();

        if (!firstLoad) initTooltips();

        /* enable add to wishlist, when the version's selectors are selected */
        var $merchantSelector = $('.x-product-details-version-selector.merchant ul .dim-item.li', $wrapper);

        $.each($merchantSelector, function (i, control) {
            var $control = $(control);

            if ($('.js-popup', $control).length > 0) {
                Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.Changed, wrapper);
                Vendd.MessageBus.subscribe(Vendd.Merchant.Messages.GetModelSuccess, wrapper, function (envelope) {
                    model = envelope.message.data.model;
                    merchantPopUp(model);
                });
                var $dimItem = $(this).closest(".dim-item");
                var merchantId = $dimItem.data("version-id");
                Vendd.MessageBus.publish(wrapper, new Vendd.Merchant.Messages.GetModel($wrapper, merchantId));

            }
        });

        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($('.x-recipe-ingredients-wrapper', $wrapper)));
        Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($wrapper));

        formatPrices($wrapper);

        allowOnlyNumbersInput($wrapper);

        initAlreadyInCart();
        slickAriaFix();
        if (!firstLoad)
            addToAnyInit();

        //Init plugin for sticky 
        initStickyColumn();
    };

    wrapper.update = function () {
        wrapper.loading(true);

        firstLoad = false;

        /* Already in wishlist and compare start */
        if (wishlistModel) {
            wishlistModel.Items.forEach(function (item) {
                if (item.VariantId == model.SelectedProductId) {
                    model.AlreadyInWishlist = true;
                    return;
                }
            });
        }
        if (compareModel) {
            compareModel.Items.forEach(function (item) {
                if (item.Id == model.ParentProductId) {
                    model.AlreadyInCompare = true;
                    return;
                }
            });
        }

        /* Already in wishlist and compare end */

        if (typeof canonicalBreadcrumb !== 'undefined') {
            model = $.extend({}, canonicalBreadcrumb, model);
        }

        if (model.Dimensions.length > 0) {

            /* Dropdown Selectors - On Color Change, Hide the Colors Photogallery */
            //var colorSelector = $('.x-product-details-version-selector select.dim-0-select');
            //if (colorSelector.length > 0) {
            //    model.Dimensions[0].Versions.forEach(function (ver) {
            //        if (ver.Selected) {
            //            model.HideColorsGallery = true;
            //            return;
            //        }
            //    });
            //}
            //var colorSelector = $('.x-product-details-version-selector select.dim-0-select');
            //if (colorSelector.length > 0) {
            //    if (colorSelector.val() == 0) {
            //        model.Dimensions[0].Versions.forEach(function (ver) { ver.Selected = false; });
            //        model.Dimensions[0].DefaultSkuLoaded = true;
            //        model.DefaultSkuLoaded = true;
            //        if (!model.Buttons.CartEnabled) {
            //            var quantitySelector = $('.x-product-details-quantity-selector .js-selector');
            //            $('option', quantitySelector).each(function () {
            //                var quantityElement = {};
            //                quantityElement.Value = $(this).attr('value');
            //                quantityElement.Selected = $(this).attr('selected') !== undefined;
            //                model.Quantities.push(quantityElement);
            //            });
            //            model.Buttons.CartEnabled = true;
            //        }
            //        model.Buttons.HasAddToCart = false;
            //        model.Buttons.HasAddToProductCompare = false;
            //        model.Buttons.HasAddToWishlist = false;
            //        model.AvailabilityNoticationForm.Visible = false;
            //    }
            //}

            //var sizeSelector = $('.x-product-details-version-selector select.dim-1-select');
            //if (sizeSelector.length > 0) {
            //    if (sizeSelector.val() == 0) {
            //        model.Dimensions[1].Versions.forEach(function (ver) { ver.Selected = false; });
            //        model.Dimensions[1].DefaultSkuLoaded = true;
            //        if (!model.Buttons.CartEnabled) {
            //            var quantitySelector = $('.x-product-details-quantity-selector .js-selector');
            //            $('option', quantitySelector).each(function () {
            //                var quantityElement = {};
            //                quantityElement.Value = $(this).attr('value');
            //                quantityElement.Selected = $(this).attr('selected') !== undefined;
            //                model.Quantities.push(quantityElement);
            //            });
            //            model.Buttons.CartEnabled = true;
            //        }
            //        //model.Quantities[0] = { Value: 1, Selected: true };
            //        model.DefaultSkuLoaded = true;
            //        model.Buttons.HasAddToCart = false;
            //        model.Buttons.HasAddToProductCompare = false;
            //        model.Buttons.HasAddToWishlist = false;
            //        model.AvailabilityNoticationForm.Visible = false;
            //    }
            //}
            /* Dropdown Selectors */


            /* Dropdown Selectors - PLAYCITYRE-243 */
            var $pdVersionSelector = $('.versions-container .x-product-details-version-selector', $wrapper);

            if ($pdVersionSelector.hasClass('sku-list')) {
                if ($('ul > li.sku-item.selected').length > 0) {
                    model.ColorIsSelected = true;
                    model.SizeIsSelected = true;
                }
            } else {
                var $colorSelector = $('select.dim-0-select', $pdVersionSelector),
                    $sizeSelector = $('select.dim-1-select', $pdVersionSelector),
                    hasColorSelector = false, hasSizeSelector = false;

                if ($colorSelector.length > 0) hasColorSelector = true;
                if ($sizeSelector.length > 0) hasSizeSelector = true;

                model.ColorIsSelected = false;
                model.SizeIsSelected = false;

                if (hasColorSelector && $colorSelector.val() !== "0") {
                    model.ColorIsSelected = true;
                }

                if (hasSizeSelector && $sizeSelector.val() !== "0") {
                    model.SizeIsSelected = true;
                }

                if (hasColorSelector) { 
                    if ($colorSelector.val() === "0") {
                        model.Dimensions.find(function (dim) { return dim.IsColor == true; }).Versions.forEach(function (ver) { ver.Selected = false; });
                        model.ColorIsSelected = false;
                        model.Buttons.HasAddToCart = false;
                        model.Buttons.HasAddToProductCompare = false;
                        model.Buttons.HasAddToWishlist = false;
                        model.AvailabilityNoticationForm.Visible = false;
                    } else {
                        if (!model.SizeIsSelected && hasSizeSelector) {
                            model.Dimensions.find(function (dim) { return dim.IsColor == true; }).Versions.forEach(function (ver) { ver.Disabled = false; });
                        }
                    }
                }

                if (hasSizeSelector) {
                    if ($sizeSelector.val() === "0") {
                        model.Dimensions.find(function (dim) { return dim.IsSize == true; }).Versions.forEach(function (ver) { ver.Selected = false; });
                        model.Buttons.HasAddToCart = false;
                        model.Buttons.HasAddToProductCompare = false;
                        model.Buttons.HasAddToWishlist = false;
                        model.AvailabilityNoticationForm.Visible = false;
                    } else {
                        if (!model.ColorIsSelected && hasColorSelector) {
                            model.Dimensions.find(function (dim) { return dim.IsSize == true; }).Versions.forEach(function (ver) { ver.Disabled = false; });
                        }
                    }
                }
            }
            /* List Selectors */
        }

        var html;
        if ($wrapper.hasClass('x-product-details-popup')) {
            model.IsPopUp = true;
            html = Vendd.Handlebars.parse("productDetailsPopup_A", model);
            //update data attributes
            $wrapper.attr('data-parent-id', model.ParentProductId);
            $wrapper.attr('data-selected-id', model.SelectedProductId);
            $wrapper.attr('data-path', model.PathChecksum);
        } else {
            var state = Vendd.Product.Controller.getState();
            state.selectedColorId = model.SelectedProductColorId;
            html = Vendd.Handlebars.parse("productDetails_B", model);
            //update data attributes
            $wrapper.attr('data-selected-id', model.SelectedProductId);
        }

        //Get Same Day Delivery widget
        var sameDayDelivery = $('.x-same-day-delivery', $wrapper); 
        //Get Klarna placement
        var klarnaPlacement = $('[data-key=credit-promotion-badge]', $wrapper); 
        //Get Reviews Summary
        var pdReviewsSummary = $('.x-pd-reviews-summary', $wrapper);
        //Get Size Guide
        var sizeGuide = $('.js-go-to-size-guide', $wrapper);
        //Get Back to List url
        var backToList = $('.back-to-list', $wrapper);
        //Get Usps Html
        var uspsHtml = $('.pd-usps', $wrapper);
        //Get Promo Menu
        var promoMenu = $('.pd-promo-menu', $wrapper);
        //Get add ons
        var addOns = $('.x-product-details-add-ons', $wrapper);
        //Get replacedBy Html
        var replacedBy = $('.x-replaced-products', $wrapper);
        //Get Cart Counter
        var inCartCounter = $('.in-details.in-cart-wrapper', $wrapper);

        $wrapper.html(html);

        //Add Same Day Delivery widget
        if (sameDayDelivery.length > 0)
            $('.pd-box-dimensions-selector', $wrapper).append(sameDayDelivery);
        //Add klarna placement
        if (klarnaPlacement.length > 0)
            $('.pd-box-dimensions-selector', $wrapper).append(klarnaPlacement);
        //Add Reviews Summary to the wrapper
        if (pdReviewsSummary.length > 0)
            $('.pd-inner-area-one', $wrapper).append(pdReviewsSummary);
        //Add Size Guide to the wrapper
        if (sizeGuide.length > 0)
            $('.pd-box-three .x-product-details-version-selector.size', $wrapper).prepend(sizeGuide);
        // Add Back To List url to the wrapper
        if (backToList.length > 0)
            $('.pd-inner-area-one', $wrapper).prepend(backToList);
        //Add Usps Html to the wrapper
        if (uspsHtml.length > 0)
            $('.pd-inner-area-three', $wrapper).append(uspsHtml);
        //Add Promo Menu to the wrapper
        if (promoMenu.length > 0)
            $('.pd-box-promo-menu', $wrapper).append(promoMenu);
        //Add add ons
        if (addOns.length > 0)
            $('.pd-box-dimensions-selector', $wrapper).prepend(addOns);
        //Replace Cart Counter
        if (inCartCounter.length > 0)
            $('.in-details.in-cart-wrapper', $wrapper).replaceWith(inCartCounter);

        if (typeof replacedBy !== 'undefined') {

            $('.pd-box-replaced-by-products', $wrapper).append(replacedBy);

            $('.js-show-replaced-products').fancybox({
                baseTpl:
                    '<div class="fancybox-container replaced-products" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-inner">' +
                    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                    '<div class="fancybox-toolbar">{{buttons}}</div>' +
                    '<div class="fancybox-navigation">{{arrows}}</div>' +
                    '<div class="fancybox-stage"></div>' +
                    '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
                    '</div>' +
                    '</div>'
            });
            
        }

        $wrapper.find('.availability-container').addClass('visible');

        wrapper.updateUrl(model);

        wrapper.bind();

        wrapper.loading(false);
    };

    wrapper.updateOnlyPrices = function () {
        //update prices
        var $pricesCont = $('.prices-container', $wrapper);

        if (model.Prices.ShowPriceWithoutVat) {
            $('.current-price-container .current-price', $pricesCont).text(model.Prices.UnitPriceWithoutVat);
            $('.deleted-price .value', $pricesCont).text(model.Prices.DeletedPriceWithoutVat);
            $('.discount .value', $pricesCont).text(model.Prices.DiscountValueWithoutVat);
            $('.points-gain-container .points-gain', $pricesCont).text(model.Prices.TotalPointsGain);
        } else {
            $('.current-price-container .current-price', $pricesCont).text(model.Prices.UnitPrice);
            $('.deleted-price .value', $pricesCont).text(model.Prices.DeletedPrice);
            $('.discount .value', $pricesCont).text(model.Prices.DiscountValue);
            $('.points-gain-container .points-gain', $pricesCont).text(model.Prices.TotalPointsGain);
        }
        $('.discount-percentage .value', $pricesCont).text('-' + model.Prices.DiscountPercentage + '%');

        $pricesCont.removeClass('hidden');

        //update discount tag
        var $discountTag = $('.x-product-details-tags .tag.discount', $wrapper);
        $discountTag.empty().append('<span>-' + model.Prices.DiscountPercentage + '%</span>');

        //update availability
        var $availabilityCont = $('.availability-container', $wrapper);
        $availabilityCont.empty().append('<span class="availability pd-availability-' + model.AvailabilityActionId + ' icon-type-' + model.AvailabilityActionId + '">' + model.AvailabilityName + '</span>');
        $availabilityCont.removeClass('hidden');
    };

    wrapper.updateUrl = function (model) {

        if (venddProjectConfigs && venddProjectConfigs.ProductDetails && venddProjectConfigs.ProductDetails.updateUrlOnSkuChange) {
            var updateUrl = false;

            if (model) {
                if (model.Dimensions.length >= 2) {
                    if (model.ColorIsSelected && model.SizeIsSelected) {
                        updateUrl = true;
                    }
                } else {
                    if (model.ColorIsSelected || model.SizeIsSelected) {
                        updateUrl = true;
                    }
                }
            } else {
                if ($wrapper.data('default-sku-loaded').toLowerCase().trim() === "false") {
                    updateUrl = true;
                }
            }

            if (updateUrl) {
                var url = window.location.href;
                var selectedId = model ? model.SelectedProductId : $wrapper.data('selected-id');

                //remove querystring if exists
                if (url.indexOf('skuid=') > -1) {
                    url = LhApp.Function.Url.removeParameterFromUrl(url, 'skuid');
                }
                //add new querystring
                url = LhApp.Function.Url.setParameterValueOnUrl(url, 'skuid', selectedId);
                //change url
                history.replaceState({}, '', url);
            }
        }

    };

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.model;

        if (lazyLoadSender && (venddProjectConfigs && venddProjectConfigs.ProductDetails && venddProjectConfigs.ProductDetails.updateOnlyPrices)) {
            wrapper.updateOnlyPrices();
            lazyLoadSender = false;
        } else {
            wrapper.update();
        } 
    });

    //show in cart message
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, 'x-product-details', function (envelope) {
        var model = envelope.message.data.Cart;
        var id = $wrapper.data('parent-id');
        var quantityInCart = 0, idsInCart = [], inCart = false;

        $wrapper.find('.js-remove-from-cart').attr('disabled', 'disabled').parent().addClass('disabled');

        for (var j = 0; j < model.Items.length; j++) {
            if (id == model.Items[j].ProductId) {
                quantityInCart += model.Items[j].Quantity;
                idsInCart.push(model.Items[j].Id);
                inCart = true;
            }
        }

        var decRegex = /^[0-9]*(\.[0-9]+)$/;
        if (decRegex.test(quantityInCart)) {
            quantityInCart = quantityInCart.toFixed(2);
        }

        if (inCart) {
            $wrapper.prop('data-cartproductid', idsInCart);
            $wrapper.find('.js-remove-from-cart').removeAttr('disabled').parent().removeClass('disabled');
            if (!model.CountAsOneInCart) $wrapper.find('.js-cart-quantity').text("(" + quantityInCart + ")");
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, wrapper, function (envelope) {
        wishlistModel = envelope.message.data;
        var state = Vendd.Product.Controller.getState();
        var skuId = state.selectedId;

        if (wishlistModel) {
            var productInWishlist = wishlistModel.Items.find(function (x) { return skuId === x.VariantId });
            var $wishlistButton = $('.x-product-details-ajax-buttons .wishlist-button', $wrapper);

            if (productInWishlist) {
                $wishlistButton.addClass('already-in-wishlist');
                $('.js-add-to-wishlist', $wishlistButton).addClass('disabled');
                $('.js-remove-from-wishlist', $wishlistButton).removeClass('disabled');
            } else {
                $wishlistButton.removeClass('already-in-wishlist');
                $('.js-add-to-wishlist', $wishlistButton).removeClass('disabled');
                $('.js-remove-from-wishlist', $wishlistButton).addClass('disabled');
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetWidgetModelSuccess, wrapper, function (envelope) {
        compareModel = envelope.message.data.model;
        var state = Vendd.Product.Controller.getState();
        var parentId = state.parentId;

        if (compareModel) {
            var productInCompare = compareModel.Items.find(function (x) { return parentId === x.Id });
            var $compareButton = $('.x-product-details-ajax-buttons .compare-button', $wrapper);

            if (productInCompare) {
                $compareButton.addClass('already-in-compare');
                $('.js-add-to-compare', $compareButton).addClass('disabled');
                $('.js-remove-from-compare', $compareButton).removeClass('disabled');
            } else {
                $compareButton.removeClass('already-in-compare');
                $('.js-add-to-compare', $compareButton).removeClass('disabled');
                $('.js-remove-from-compare', $compareButton).addClass('disabled');
            }
        }
    });

    lazyLoadPrices();

    lazyLoadAvailabilities();

    wrapper.bind();

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    if (LhApp.Context.LastViewedProducts != undefined && funcCookiesEnabled) {
        if (LhApp.Context.LastViewedProducts.LastViewedProductsIsActive) {
            var expirationDays = LhApp.Context.LastViewedProducts.LastViewedProductsExpirationDays;
            var productNumber = LhApp.Context.LastViewedProducts.LastViewedProductsNumber;
            var productId = LhApp.Context.Item.Id;

            var products = Cookies.get("LastViewedProducts") || "";
            var productsArray = reject(products.split(","), function (el) { return el == productId || el == ""; });
            productsArray.unshift(productId);
            var cookieValue = productsArray.slice(0, productNumber).join(",");
            var expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
            Cookies.set("LastViewedProducts", cookieValue, { secure: LhApp.Context.Request.IsSecure, expires: expireDate, samesite: 'Lax' });
        }
    }

    function initAlreadyInCart() {
        if ($('.in-details .js-remove-from-cart', $wrapper).length < 1)
            return;

        var removeCartBtn = $('.in-details .js-remove-from-cart', $wrapper);

        removeCartBtn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), cartIds;

            cartIds = $wrapper.prop('data-cartproductid');

            Vendd.MessageBus.publishAsync($wrapper.get(0), new Vendd.Cart.Messages.MultipleRemove(cartIds));

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, $wrapper, function (envelope) {
                $this.attr('disabled', 'disabled').parent().addClass('disabled');
                toastr.success(envelope.message.data.data.SuccessMessage, "", { timeOut: 1200, showDuration: 1000, hideDuration: 700 });
                Vendd.MessageBus.unsubscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, $wrapper);
            });
        });
    }

    function initStickyColumn() {
        if ($('.sticky-column').length < 1) return;

        var sidebar = new StickySidebar('.sticky-column', {
            topSpacing: $('.sticky-column').data('top-spacing') || 50,
            bottomSpacing: $('.sticky-column').data('bottom-spacing') || 0,
            containerSelector: '.sticky-full',
            innerWrapperSelector: '.inner-sticky-column',
            resizeSensor: true,
            minWidth: 960

        });

        $(window).resize($.debounce(700, function (e) {
            if (!isTouch() || (isTouch() && $(window).outerWidth() > 959)) {
                $("html, body").animate({ scrollTop: 0 }, 1);
            }          
        }));

        if ($('.x-product-details-photo-gallery .main-gallery > ul > li').length > 0) {
            setInterval(function () {
                if ((!isTouch() || (isTouch() && $(window).outerWidth() > 959)) && $('.x-product-details-photo-gallery .main-gallery > ul').hasClass("slick-initialized") ) {
                    $('.x-product-details-photo-gallery .main-gallery > ul').slick('setPosition');
                    sidebar.updateSticky();
                }
            }, 500);
        }

    }

    function lazyLoadPrices() {

        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
            var lazyLoadPrices = $('.details-lazy-load-prices').text().toLowerCase().trim() === "true";
            var customPrices = envelope.message.data.model.HasCustomPrices;
            var skuQueryString = getQueryStringValueByName('skuid').length > 0;

            if (lazyLoadPrices || customPrices || skuQueryString) {
                //variable for updateOnlyPrices
                lazyLoadSender = $wrapper.data('default-sku-loaded').toLowerCase().trim() == "true" ? true : false;
                //destroy photo gallery spinner
                deleteSpinnerInstances();
                //set selected sku
                var skuId = parseInt($('.x-control.x-product-details[data-selected-id]').attr('data-selected-id'));
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.SetSelected({ id: skuId, visitorInitiated: false }));
            } else {
                wrapper.updateUrl(model);
            }
            
        });

    }

    function lazyLoadAvailabilities() {

        var lazyLoadAvailabilities = $('.details-lazy-load-availabilities').text().toLowerCase().trim() === "true";
       
        if (lazyLoadAvailabilities) {

            var deliveryPointModel = JSON.parse(localStorage.getItem("CurrentDeliveryPointModel"));
            if (deliveryPointModel) if (deliveryPointModel.data.HasDeliveryPoint) var deliveryPointId = deliveryPointModel.data.DeliveryPoint.Id;
            var deliveryPostalCode = Cookies.get('DeliveryPostalCode');

            if (deliveryPointId == 1 && deliveryPostalCode && deliveryPostalCode !== 'undefined') {
                //set variant id
                var skuId = parseInt($('.x-control.x-product-details[data-selected-id]').attr('data-selected-id'));
                //set variant array
                var variantArray = [];
                var variant = {
                    VariantId: skuId,
                    Quantity: '1'
                };
                variantArray.push(variant);

                //call service for delivery availabilities
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetDeliveryAvailability(variantArray, deliveryPostalCode, null, true));

            } else if (deliveryPointId == 2) {
                //set variant id
                var skuId = parseInt($('.x-control.x-product-details[data-selected-id]').attr('data-selected-id'));
                //set selected shop id
                var partnerId = deliveryPointModel.data.Store.Id
                //set variant array
                var variantArray = [];
                var variant = {
                    VariantId: skuId,
                    Quantity: '1'
                };
                variantArray.push(variant);

                //call service for pick up availabilities
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetPickUpAvailability(variantArray, partnerId, true));

                Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetPickUpAvailabilitySuccess, wrapper, function (envelope) {
                    var data = envelope.message.data;

                    //Set Pick Up Availability ID
                    var availability = data.PickupAvailabilities[0].Shops[0].Message;
                    var availabilityId;
                    if (data.PickupAvailabilities[0].Shops[0].Days == null) {
                        availabilityId = 1;
                    } else {
                        availabilityId = 3;
                    }

                    //Show Delivery Availability
                    $('.x-product-details .lazyload-availability-container > span').remove();
                    $('.x-product-details .lazyload-availability-container').append('<span class="availability availability-' + availabilityId + ' icon-type-' + availabilityId + '">' + availability + '</span>');

                    Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.GetPickUpAvailabilitySuccess, wrapper);
                });
            }
        }
    }
    function slickAriaFix() {

        var $photoGallery = $('.x-product-details-photo-gallery');

        if ($photoGallery.length < 1)
            return;

        $('.image-container', $photoGallery).each(function () {
            var $slide = $(this).parent();
            if ($slide.attr('aria-describedby') != undefined) {
                $(this).attr('id', $slide.attr('aria-describedby'));
            }
        });
    };
    function addToAnyInit() {
        if (typeof a2a !== 'undefined') {
            a2a_config.target = '.share-this';
            a2a_config.onclick = 1;
            a2a_config.num_services = 6;
            a2a_config.prioritize = ['facebook_messenger', 'viber', 'gmail', 'email', 'x', 'whatsapp'];
            a2a_config.custom_services = [
                ['Instagram',
                    "https://www.instagram.com/?url=A2A_LINKURL_ENC&title=A2A_LINKNAME_ENC",
                    "/Themes/templateThemeTwo/images/addToAny/Instagram_logo.svg",
                ]
            ];
            a2a_config.exclude_services = [
                'wykop', 'yummly', 'xing', 'wordpress', 'wechat', 'vk', 'typepad_post', 'twiddla', 'trello', 'threema', 'symbaloo_bookmarks',
                'svejo', 'stocktwits', 'slashdot', 'refind', 'sitejot', 'rediff', 'qzone', 'pusha', 'printfriendly', 'plurk',
                'pinboard', 'papaly', 'odnoklassniki', 'myspace', 'mixi', 'meneame', 'mendeley', 'mewe', 'mail_ru', 'livejournal',
                'line', 'known', 'kindle_it', 'kakao', 'instapaper', 'houzz', 'hatena', 'hacker_news', 'google_classroom', 'folkd',
                'fark', 'douban', 'draugiem', 'diigo', 'diary_ru', 'citeulike', 'box_net', 'bookmarks_fr', 'blogmarks', 'blogger',
                'bitty_browser', 'bibsonomy', 'balatarin', 'pocket', 'tumblr', 'amazon_wish_list', 'aol_mail', 'telegram',
                'diaspora', 'buffer', 'flipboard', 'digg', 'evernote', 'mastodon', 'sina_weibo'
            ];
            a2a.init('page');
        }
    }
});

